<template>
    <div class="justify-start items-center gap-2 inline-flex">
        <i class="fa-thin fa-user fa-sm"></i>
        <div class="text-slate-500 text-sm font-normal leading-tight">
            {{ user.userName }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        user: Object,
    },
    setup() {
        return {};
    },
};
</script>
